module.exports = __webpack_public_path__ + "908e4d2e/img/google.68f3823e.svg";